import { getMessages } from '../../../../../../store/constants';

export const ASIDE_PANE_COMMENTS_COLUMN_TOOLTIP = getMessages().getText('card_form_comments_column_tooltip');
export const ASIDE_PANE_COMMENTS_COLUMN_TOOLTIP_COLUMNS = getMessages().getText('card_form_comments_column_tooltip_columns');
export const ASIDE_PANE_COMMENTS_COLUMN_HINT = getMessages().getText('card_form_comments_column_hint');
export const ASIDE_PANE_COMMENTS_COLUMN_ANIMATION = 700;
export const ASIDE_PANE_COMMENTS_COLUMN_HIGHLIGHT_ANIMATION = 500; // same in _AsidePanelCommentsColumnViewButton.scss
